import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import s from '../../../../../redux/selectors';
import { wrap, withT } from '../../../../../lib/wrappers';

import InlineInput from '../InlineInput';
import InlineSelect from '../InlineSelect';

const percentTimeOptions = [
  { value: '0.25', display: '25%' },
  { value: '0.5', display: '50%' },
  { value: '0.75', display: '75%' },
  { value: '1', display: '100%' },
];

const PowerManagementOfComputers = ({
  t,
  widgetSource,
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <p>
        {t('I have')}
        <InlineInput
          maxLength={3}
          apiKey={'input_takeaction_power_mgmt_comp_desktops'}
        />
        {t('desktops and')}
        <InlineInput
          maxLength={3}
          apiKey={'input_takeaction_power_mgmt_comp_monitors'}
        />
        {t('monitors')}.
      </p>
      <p>
        {t('I will put')}
        <InlineSelect
          options={percentTimeOptions}
          apiKey={'input_takeaction_power_mgmt_comp_percent_d'}
        />
        {t('of my desktop in sleep or hibernate mode during nights and weekends and turn off')}
        <InlineSelect
          options={percentTimeOptions}
          apiKey={'input_takeaction_power_mgmt_comp_percent_m'}
        />
        {t('of my monitors during nights and weekends.')}
      </p>
    </div>
    <div className="action-details__links">
      {widgetSource !== 'ontario' && <a
        href="http://www.coolcalifornia.org/funding-wizard#search//%255BZipcode%253D%253D94720%255D%255BEligible+Applicants%253D%253DIndividual%255D%255BCategory%253D%253DEnergy%255D/false/none/false/1/12"
        target="_blank"
        rel="noopener noreferrer"
      >{t('Find rebates and incentives for this action')}</a>}
    </div>
    <div className="action-details__assumptions">
      <div className="action-details__assumptions__header">{t('Assumptions')}</div>
      <ul>
        <li>
          {t('You save 500 kWh every year from putting computers in sleep mode.')}
        </li>
        <li>
          {t('You save 250 kWh every year from putting your monitors in sleep mode.')}
        </li>
      </ul>
    </div>
  </div>
);

PowerManagementOfComputers.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
  // connected props
  widgetSource: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => []
.reduce((resultProps, resultKey) => ({
  ...resultProps,
  [resultKey]: s.results(resultKey)(state, ownProps),
}), {
  widgetSource: s.widgetSource(state),
});

const mapDispatchToProps = (_dispatch, _ownProps) => ({});

export default wrap(
  withT('powerMgmtComp'),
  connect(mapStateToProps, mapDispatchToProps)(PowerManagementOfComputers),
);
